<template>
    <apexchart :width="width" :options="options" :series="options.series"></apexchart>
</template>

<script>

export default{
  name: 'LineChart',
  props: {
    xasis: Array,
    data: Array,
    title: String,
    title_y: String,
    width: String
  },
  data() {
    let colors = [];

    if (this.data.length > 1) {
      this.data.map( (data) => {
        colors.push(
          '#'+parseInt((Math.random() * 0xFFFFFF)).toString(16).padStart(6, '0')
        );
      })
    } else {
      colors = ['#AF104C'];
    }


    return {
      options: {
        series: this.data,
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: false
        },
        theme: {
          monochrome: {
            enabled: true,
            color: '#AF104C'
          }
        },
        // colors,
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: this.title,
          align: 'center'
        },
        grid: {
          row: {
            colors: ['#AF104C', 'transparent'], 
            opacity: 0.04
          },
        },
        yaxis: {
          title: {
            text: this.title_y
          }
        },
        xaxis: {
          categories: this.xasis,
        }
      }
    }
  }
}
</script>
